import { render } from "./EconomicReport.vue?vue&type=template&id=d94e4266&scoped=true"
import script from "./EconomicReport.vue?vue&type=script&lang=js"
export * from "./EconomicReport.vue?vue&type=script&lang=js"

import "./EconomicReport.vue?vue&type=style&index=0&id=d94e4266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94e4266"]])

export default __exports__